function extract(roles) {
  if (roles == null) {
    return {};
  }
  const r = {};
  roles.forEach(role => {
    if (Array.isArray(role.userRoles)) {
      role.userRoles.forEach(userRole => {
        const {
          resourceId
        } = userRole;
        if (resourceId) {
          const isCustom = role.scope === 'custom';
          const isAdmin = role.projectId === 'imagine' && role.name === 'Admin' || role.metadata?.isAdmin === true || false;
          if (r[resourceId] == null) {
            r[resourceId] = {
              isAdmin,
              roleIds: {
                [role.id]: true
              },
              customRoleIds: {},
              roles: [role],
              customRoles: []
            };
          } else {
            r[resourceId].isAdmin = r[resourceId].isAdmin || isAdmin;
            r[resourceId].roles.push(role);
            r[resourceId].roleIds[role.id] = true;
          }
          if (isCustom) {
            r[resourceId].customRoles.push(role);
            r[resourceId].customRoleIds[role.id] = true;
          }
        }
      });
    }
  });
  return r;
}
export default {
  extract
};